/* src/app/shared/components/flow-select/flow-select.component.scss */
.flow-select {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.select-title {
  color: #18181b;
}
.select-anchor {
  position: relative;
}
.select-button {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #f4f4f5;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s;
}
.select-button.leading {
  justify-content: flex-start;
}
.select-button:not(.disabled):hover {
  background: #e4e4e7;
}
.select-button.has-selection:not(.disabled):hover .select-label {
  color: #18181b;
}
.select-button.open {
  border-color: #e4e4e7;
  background: #ffffff;
}
.select-button.error {
  border-color: #b91c1c;
  box-shadow: 0 0 0 2px #fecaca;
}
.select-button:focus-visible:not(.open):not(.error) {
  border-color: #5580dc;
  background: #ffffff;
  box-shadow: 0 0 0 3px #a2c1ee;
}
.select-button.disabled {
  background: #f4f4f5;
  cursor: default;
}
.select-button.disabled .select-label {
  color: #a1a1aa !important;
}
.select-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #18181b;
}
.select-label.placeholder {
  color: #71717a !important;
}
.chevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: transform 0.2s ease-in-out;
}
.chevron.open {
  transform: rotate(180deg);
}
/*# sourceMappingURL=flow-select.component.css.map */
